import { queryOptions } from '@tanstack/react-query';
import * as checkInsApi from '../endpoints/check-ins';
import type { PaginatedCheckInResponseWire } from '../schemas/check-in';

export const CHECK_INS_QUERY_KEYS = {
  all: ['check-ins'] as const,
  myActive: () => [...CHECK_INS_QUERY_KEYS.all, 'my', 'active'] as const,
} as const;

export const myActiveCheckInsQueryOptions = () =>
  queryOptions({
    queryKey: CHECK_INS_QUERY_KEYS.myActive(),
    queryFn: async (): Promise<PaginatedCheckInResponseWire> => {
      return checkInsApi.getMyCheckIns({ status: 'active', per_page: 1, page: 1 });
    },
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 15,
    meta: { persist: false },
  });
